 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/Cover'
 import XHTML01_HALFTITLE from '@/components/xhtml/01_halftitle'
 import XHTML02_AUTHOR_PAGE from '@/components/xhtml/02_author_page'
 import XHTML03_TITLE from '@/components/xhtml/03_title'
 import XHTMLCOPYRIGHT from '@/components/xhtml/Copyright'
 import XHTMLTOC from '@/components/xhtml/toc'
 import XHTML04_ACKNOWLEDGEMENTS from '@/components/xhtml/04_acknowledgements'
 import XHTML05_FOREWORD from '@/components/xhtml/05_foreword'
 import XHTML06_INTRODUCTION from '@/components/xhtml/06_introduction'
 import XHTML07_CHAPTER_01 from '@/components/xhtml/07_chapter_01'
 import XHTML07_CHAPTER_01A from '@/components/xhtml/07_chapter_01a'
 import XHTML07_CHAPTER_01B from '@/components/xhtml/07_chapter_01b'
 import XHTML08_CHAPTER_02 from '@/components/xhtml/08_chapter_02'
 import XHTML08_CHAPTER_02A from '@/components/xhtml/08_chapter_02a'
 import XHTML09_CHAPTER_03 from '@/components/xhtml/09_chapter_03'
 import XHTML10_CHAPTER_04 from '@/components/xhtml/10_chapter_04'
 import XHTML11_CHAPTER_05 from '@/components/xhtml/11_chapter_05'
 import XHTML12_CHAPTER_06 from '@/components/xhtml/12_chapter_06'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/toc",
 			"name" : "xhtml/toc",
 			"component" : XHTMLTOC
 		},
 		{
 			"path" : "/xhtml/04_acknowledgements",
 			"name" : "xhtml/04_acknowledgements",
 			"component" : XHTML04_ACKNOWLEDGEMENTS
 		},
 		{
 			"path" : "/xhtml/05_foreword",
 			"name" : "xhtml/05_foreword",
 			"component" : XHTML05_FOREWORD
 		},
 		{
 			"path" : "/xhtml/06_introduction",
 			"name" : "xhtml/06_introduction",
 			"component" : XHTML06_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/07_chapter_01",
 			"name" : "xhtml/07_chapter_01",
 			"component" : XHTML07_CHAPTER_01
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js